import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import EmptyContent from '@/pages/Dashboard/Layout/EmptyContent'
import NotFound from '@/pages/GeneralViews/NotFoundPage'
import DashboardLayout from '@/pages/Dashboard/Layout/DashboardLayout'
import UserIndex from '@/pages/Dashboard/Pages/Settings/Users/Index'
// Authehtification pages
import Login from '@/pages/Dashboard/Pages/Auth/Login'
import Logout from '@/pages/Dashboard/Pages/Auth/Logout'
import ForgotPassword from '@/pages/Dashboard/Pages/Auth/ForgotPassword'
import ResetPassword from '@/pages/Dashboard/Pages/Auth/ResetPassword'
// Dashboard page
import Dashboard from '@/pages/Dashboard/Pages/Dashboard'

// Orders page
import OrderIndex from '@/pages/Dashboard/Pages/Orders/Index'
import OrderShow from '@/pages/Dashboard/Pages/Orders/Show'
import OrderForm from '@/pages/Dashboard/Pages/Orders/Form'

// Pos page
import PoIndex from '@/pages/Dashboard/Pages/Pos/Index'
import PoShow from '@/pages/Dashboard/Pages/Pos/Show'
import PoForm from '@/pages/Dashboard/Pages/Pos/Form'

// Stock In page
import StockInIndex from '@/pages/Dashboard/Pages/StockIn/Index'
// import StockInShow from '@/pages/Dashboard/Pages/StockIn/Show'
// import StockInForm from '@/pages/Dashboard/Pages/StockIn/Form'
import ReturnStockForm from '@/pages/Dashboard/Pages/StockIn/FormStockReturn'

// Product Favorite page
import ProductFavoriteIndex from '@/pages/Dashboard/Pages/ProductFavorites/Index'
import ProductFavoriteShow from '@/pages/Dashboard/Pages/ProductFavorites/Show'

// Reports page
import ReportIndex from '@/pages/Dashboard/Pages/Reports/Index'

// Categories page
import CategoriesIndex from '@/pages/Dashboard/Pages/Settings/Categories/Index'

// Sablon page
import SablonIndex from '@/pages/Dashboard/Pages/Settings/Sablon/Index'

// Category Customer page
import CategoryCustomerIndex from '@/pages/Dashboard/Pages/Settings/CategoryCustomers/Index'

// Color page
import ColorIndex from '@/pages/Dashboard/Pages/Settings/Colors/Index'

// Customer page
import CustomerIndex from '@/pages/Dashboard/Pages/Settings/Customers/Index'
import CustomerShow from '@/pages/Dashboard/Pages/Settings/Customers/Show'
import CustomerForm from '@/pages/Dashboard/Pages/Settings/Customers/Form'

// Product page
import ProductIndex from '@/pages/Dashboard/Pages/Products/Index'
import ProductShow from '@/pages/Dashboard/Pages/Products/Show'
import ProductForm from '@/pages/Dashboard/Pages/Products/Form'
import ChangePriceForm from '@/pages/Dashboard/Pages/Products/ChangePrice'

// Size page
import SizeIndex from '@/pages/Dashboard/Pages/Settings/Sizes/Index'

// Supplier page
import SupplierIndex from '@/pages/Dashboard/Pages/Settings/Suppliers/Index'
import SupplierShow from '@/pages/Dashboard/Pages/Settings/Suppliers/Show'
import SupplierForm from '@/pages/Dashboard/Pages/Settings/Suppliers/Form'

// Owner page
import SettingOwnerUserIndex from '@/pages/Dashboard/Pages/Settings/Users/Owners/Index'
import SettingOwnerUserShow from '@/pages/Dashboard/Pages/Settings/Users/Owners/Show'
import SettingOwnerUserForm from '@/pages/Dashboard/Pages/Settings/Users/Owners/Form'

// Cashier page
import SettingCashierUserIndex from '@/pages/Dashboard/Pages/Settings/Users/Cashiers/Index'
import SettingCashierUserShow from '@/pages/Dashboard/Pages/Settings/Users/Cashiers/Show'
import SettingCashierUserForm from '@/pages/Dashboard/Pages/Settings/Users/Cashiers/Form'

// WareHouse page
import SettingWarehouseUserIndex from '@/pages/Dashboard/Pages/Settings/Users/Warehouses/Index'
import SettingWarehouseUserShow from '@/pages/Dashboard/Pages/Settings/Users/Warehouses/Show'
import SettingWarehouseUserForm from '@/pages/Dashboard/Pages/Settings/Users/Warehouses/Form'

// Web Config page
import WebConfigIndex from '@/pages/Dashboard/Pages/Settings/WebConfig/Index'

// PermissionPage
import PermissionForm from '@/pages/Dashboard/Pages/Settings/Permission/Form'

// Profile pages
import Overview from '@/pages/Dashboard/Pages/Profile/Overview'
import ChangePassword from '@/pages/Dashboard/Pages/Profile/ChangePassword'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
      }, {
        path: 'profile',
        name: 'Profile Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Profile',
            component: Overview,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }, {
            path: 'change-password',
            name: 'Change Password',
            component: ChangePassword,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }
        ]
      },
      {
        path: 'penjualan',
        name: 'Orders Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Penjualan',
            component: OrderIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }, {
            path: 'create',
            name: 'Input Penjualan',
            component: OrderForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }, {
            path: ':id/edit',
            name: 'Edit Penjualan',
            component: OrderForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }, {
            path: ':id',
            name: 'Detail Penjualan',
            component: OrderShow,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }
        ]
      },
      {
        path: 'pembelian',
        name: 'Pos Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Pembelian',
            component: PoIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }, {
            path: 'create',
            name: 'Input Pembelian',
            component: PoForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }, {
            path: ':id/edit',
            name: 'Perbarui Pembelian',
            component: PoForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }, {
            path: ':id',
            name: 'Detail Pembelian',
            component: PoShow,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }
        ]
      },
      {
        path: 'barang',
        name: 'Product Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Barang',
            component: ProductIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }, {
            path: 'create',
            name: 'Tambah Barang',
            component: ProductForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }, {
            path: ':id/edit',
            name: 'Perbaharui Barang',
            component: ProductForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }, {
            path: ':id',
            name: 'Detail Barang',
            component: ProductShow,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }, {
            path: 'ubah-harga/:id',
            name: 'Ubah Harga Barang',
            component: ChangePriceForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }
        ]
      },
      {
        path: 'stok',
        name: 'Stock In Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Return Stock',
            component: ReturnStockForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }
        ]
      },
      {
        path: 'transaksi-stok',
        name: 'transaksi In Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Stock',
            component: StockInIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }
        ]
      },
      {
        path: 'item-terlaris',
        name: 'Product Favorite Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Item Terlaris',
            component: ProductFavoriteIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }, {
            path: ':id',
            name: 'Detail Item Terlaris',
            component: ProductFavoriteShow,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }
        ]
      },
      {
        path: 'laporan',
        name: 'Laporan Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Laporan Penjualan',
            component: ReportIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }
        ]
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/pengaturan',
    component: DashboardLayout,
    redirect: '/settings/service-providers',
    children: [
      {
        path: 'pengguna',
        component: UserIndex,
        redirect: '/settings/pengguna/owner',
        children: [
          {
            path: 'owner',
            name: 'Owner User Setting Empty Container',
            component: EmptyContent,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'Daftar Owner',
                component: SettingOwnerUserIndex,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: 'create',
                name: 'Tambah Data Owner',
                component: SettingOwnerUserForm,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: ':id/edit',
                name: 'Perbarui Data Owner',
                component: SettingOwnerUserForm,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: ':id',
                name: 'Detail Owner',
                component: SettingOwnerUserShow,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }
            ]
          },
          {
            path: 'kasir',
            name: 'Kasir User Setting Empty Container',
            component: EmptyContent,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'Daftar Kasir',
                component: SettingCashierUserIndex,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: 'create',
                name: 'Tambah Data Kasir',
                component: SettingCashierUserForm,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: ':id/edit',
                name: 'Perbarui Data Kasir',
                component: SettingCashierUserForm,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: ':id',
                name: 'Detail Kasir',
                component: SettingCashierUserShow,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }
            ]
          },
          {
            path: 'gudang',
            name: 'Gudang User Setting Empty Container',
            component: EmptyContent,
            children: [
              {
                path: 'index',
                alias: '/',
                name: 'Daftar Gudang',
                component: SettingWarehouseUserIndex,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: 'create',
                name: 'Tambah Data Gudang',
                component: SettingWarehouseUserForm,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: ':id/edit',
                name: 'Perbarui Data Gudang',
                component: SettingWarehouseUserForm,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }, {
                path: ':id',
                name: 'Detail Gudang',
                component: SettingWarehouseUserShow,
                meta: { requiredAllowedRole: ['owner', 'super admin'] }
              }
            ]
          }
        ]
      },
      {
        path: 'kategori',
        name: 'Categories Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Kategori',
            component: CategoriesIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }
        ]
      },
      {
        path: 'web-config',
        name: 'Web Config Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Web Config',
            component: WebConfigIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang', 'super admin'] }
          }
        ]
      },
      {
        path: 'permission',
        name: 'permission Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar permission',
            component: PermissionForm,
            meta: { requiredAllowedRole: ['super admin', 'owner'] }
          }
        ]
      },
      {
        path: 'sablon',
        name: 'Sablon Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Sablon',
            component: SablonIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin'] }
          }
        ]
      },
      {
        path: 'warna',
        name: 'Color Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Warna',
            component: ColorIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir', 'gudang'] }
          }
        ]
      },
      {
        path: 'kategori-pelanggan',
        name: 'Category Pelanggan Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Kategori Pelanggan',
            component: CategoryCustomerIndex,
            meta: { requiredAllowedRole: ['super admin'] }
          }
        ]
      },
      {
        path: 'ukuran',
        name: 'Size Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Ukuran',
            component: SizeIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin'] }
          }
        ]
      },
      {
        path: 'pelanggan',
        name: 'Pelanggan Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Pelanggan',
            component: CustomerIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }, {
            path: 'create',
            name: 'Tambah Berita Pelanggan',
            component: CustomerForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }, {
            path: ':id/edit',
            name: 'Perbaharui Berita Pelanggan',
            component: CustomerForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }, {
            path: ':id',
            name: 'Detail Pelanggan',
            component: CustomerShow,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'kasir'] }
          }
        ]
      },
      {
        path: 'supplier',
        name: 'Supplier Setting Empty Container',
        component: EmptyContent,
        children: [
          {
            path: 'index',
            alias: '/',
            name: 'Daftar Supplier',
            component: SupplierIndex,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }, {
            path: 'create',
            name: 'Tambah Berita Supplier',
            component: SupplierForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }, {
            path: ':id/edit',
            name: 'Perbaharui Berita Supplier',
            component: SupplierForm,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }, {
            path: ':id',
            name: 'Detail Supplier',
            component: SupplierShow,
            meta: { requiredAllowedRole: ['owner', 'super admin', 'gudang'] }
          }
        ]
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  }, {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: { requiresAuth: true }
  }, {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: ForgotPassword,
    meta: { requiresGuest: true }
  }, {
    path: '/reset-password/:id',
    name: 'Reset Password',
    component: ResetPassword,
    meta: { requiresGuest: true }
  }, {
    path: '*', component: NotFound
  }, {
    path: '404', component: NotFound
  }
]

Vue.use(VueRouter)
const router = new VueRouter({
  routes, // short for router: router
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['account/isLoggedIn']) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else if (to.meta.requiredAllowedRole !== undefined && to.meta.requiredAllowedRole.length > 0 && to.meta.requiredAllowedRole.filter(role => role === store.getters['account/accountData'].roles[0].name).length < 1) {
      next({
        path: '*'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => to.meta.requiresGuest)) {
    if (store.getters['account/isLoggedIn']) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js